/**
 * Editor hand-off actions. These stash intent in sessionStorage and navigate to
 * the editor, which picks it up on mount (see pages/Editor initializeEditor):
 * - `aiGenerateOpen`   → opens the AI panel (or the "configure AI" prompt)
 * - `mermaidImport`    → opens the Mermaid import modal
 * - `importedDiagram`  → loads the given diagram JSON ({ nodes, edges })
 */

type Navigate = (path: string) => void;

/** Open the editor with the AI panel ready for a new conversation. */
export function startAIGeneration(navigate: Navigate) {
  sessionStorage.setItem('aiGenerateOpen', '1');
  navigate('/editor');
}

/** Open the editor and auto-launch the Mermaid import modal. */
export function startMermaidImport(navigate: Navigate) {
  sessionStorage.setItem('mermaidImport', '1');
  navigate('/editor');
}

/** Prompt for a diagram JSON file, then open the editor with it loaded. */
export function importDiagramFromFile(navigate: Navigate) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'application/json,.json';
  input.onchange = () => {
    const file = input.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      if (typeof text !== 'string') return;
      try {
        JSON.parse(text); // ensure it parses before handing off to the editor
      } catch {
        window.alert('Could not import: the selected file is not valid diagram JSON.');
        return;
      }
      sessionStorage.setItem('importedDiagram', text);
      navigate('/editor');
    };
    reader.readAsText(file);
  };
  input.click();
}
